import { doc, setDoc, getDoc, getDocs, collection, query, where, serverTimestamp, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import { Carrier } from './types';

export class CarrierService {
  async createCarrier(carrierData: Omit<Carrier, 'id' | 'createdAt' | 'updatedAt'>): Promise<Carrier> {
    try {
      const carrierRef = doc(collection(db, 'carriers'));
      const carrier: Carrier = {
        ...carrierData,
        id: carrierRef.id,
        createdAt: serverTimestamp() as Timestamp,
        updatedAt: serverTimestamp() as Timestamp,
      };
      
      await setDoc(carrierRef, carrier);
      return carrier;
    } catch (error) {
      console.error('Chyba pri vytváraní dopravcu:', error);
      throw new Error('Nepodarilo sa vytvoriť dopravcu');
    }
  }

  async getCarrier(carrierId: string): Promise<Carrier | null> {
    try {
      const carrierDoc = await getDoc(doc(db, 'carriers', carrierId));
      if (carrierDoc.exists()) {
        return carrierDoc.data() as Carrier;
      }
      return null;
    } catch (error) {
      console.error('Chyba pri načítaní dopravcu:', error);
      throw new Error('Nepodarilo sa načítať dopravcu');
    }
  }

  async updateCarrier(carrierId: string, updates: Partial<Carrier>): Promise<void> {
    try {
      const carrierRef = doc(db, 'carriers', carrierId);
      await updateDoc(carrierRef, {
        ...updates,
        updatedAt: serverTimestamp(),
      });
    } catch (error) {
      console.error('Chyba pri aktualizácii dopravcu:', error);
      throw new Error('Nepodarilo sa aktualizovať dopravcu');
    }
  }

  async searchCarriers(criteria: {
    type?: string;
    countries?: string[];
    specialties?: string[];
    minRating?: number;
  }): Promise<Carrier[]> {
    try {
      let carriersQuery = query(
        collection(db, 'carriers'),
        where('status', '==', 'active')
      );

      if (criteria.type) {
        carriersQuery = query(carriersQuery, where('type', '==', criteria.type));
      }

      const querySnapshot = await getDocs(carriersQuery);
      let carriers = querySnapshot.docs.map(doc => doc.data() as Carrier);

      if (criteria.countries) {
        carriers = carriers.filter(carrier => 
          criteria.countries!.some(country => 
            carrier.coverage.countries.includes(country)
          )
        );
      }

      if (criteria.specialties) {
        carriers = carriers.filter(carrier => 
          criteria.specialties!.some(specialty => 
            carrier.specialties.includes(specialty)
          )
        );
      }

      if (criteria.minRating) {
        carriers = carriers.filter(carrier => carrier.rating >= criteria.minRating!);
      }

      return carriers.sort((a, b) => b.rating - a.rating);
    } catch (error) {
      console.error('Chyba pri vyhľadávaní dopravcov:', error);
      throw new Error('Nepodarilo sa vyhľadať dopravcov');
    }
  }
}

export const carrierService = new CarrierService();

